import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import { LeadFormParameters } from 'components/LeadForm/LeadForm.data';
import styles from 'pages/benefits/Benefits.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Benefits/components/SectionHeader'));
const SectionPitch = dynamic(() => import('sections/Benefits/components/SectionPitch'));
const SectionCards = dynamic(() => import('sections/Benefits/components/SectionCards'));
const SectionFaq = dynamic(() => import('sections/Benefits/components/SectionFaq'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionForm = dynamic(() => import('sections/Benefits/components/SectionForm'));

type BenefitsProps = {
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
};

export default function BenefitsPage({ pageTitle, formUrl, leadSubtype }: BenefitsProps) {
  return (
    <div className={cn('benefits')}>
      <SectionHeader/>
      <SectionPitch/>
      <SectionCards/>
      <SectionFaq/>
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionForm 
        pageTitle={pageTitle} 
        formUrl={formUrl} 
        leadSubtype={leadSubtype}
      /> */}
    </div>
  );
};

export const getStaticProps = async () => {
  // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
  // 'FormParameters' - parameters, passed to 'Form' component in 'SectionForm' on all Benefits pages as additional data for CRM: 
  // const FormParameters = {
  //   pageTitle: LeadFormParameters.benefits.pageTitle,
  //   formUrl: LeadFormParameters.benefits.formUrl,
  //   leadSubtype: LeadFormParameters.benefits.leadSubtype,
  // };

  return {
    props: {
      title: 'Benefits of Our Freight Forwarders Association | DF Alliance',
      description: 'Discover the key benefits of working with DF Alliance, offering global logistics solutions and digital tools for optimizing your freight forwarding experience.',
      path: '/benefits',
      // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
      // ...FormParameters,
    },
  };
};

BenefitsPage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
